'use client';

import { Flex, Text } from '@/_components';
import { FC, useContext } from 'react';
import styles from './ClientMenu.module.css';
import { UserContext } from '../../UserProvider';
import type { ClientMenuProps } from './ClientMenu.types';
import { getClasses } from '@/_utils/classnames';

export const ClientMenu: FC<ClientMenuProps> = ({ isOpen, onClose }) => {
  const { companies } = useContext(UserContext);

  const clientMenuClasses: string = getClasses(styles.clientMenu, {
    [styles.clientMenuOpen]: isOpen,
  });

  const onContentClick = (event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.clientMenuContainer} onClick={onClose}>
      <Flex
        isColumn={true}
        gap={8}
        className={clientMenuClasses}
        onClick={onContentClick}
      >
        <Flex isColumn={true}>
          <Text type="small">Entities</Text>
          {companies?.map((company, key) => {
            return (
              <Flex gap={4} key={key}>
                <Text type="small">{company.name}</Text>
                <Text type="small" color="secondary">
                  {company.entity_type}
                </Text>
              </Flex>
            );
          })}
        </Flex>
      </Flex>
    </div>
  );
};
